import authApi from './authApi';
import { EXTENSION_ACTIONS } from './constants';
import { IExtensionMessage } from './types/extension';

export const chromeApi = typeof chrome !== 'undefined' ? chrome : undefined;

// Foam Extension Utils (Main Extension)
export const foamExtensionUtils = {
  sendTokenToChromeExtension: () => {
    chromeApi?.runtime?.sendMessage(
      process.env.NEXT_PUBLIC_CHROME_EXTENSION_ID ?? '',
      {
        action: EXTENSION_ACTIONS.login,
        jwt: authApi.jwtAccessToken,
      },
    );
  },

  sendLogoutToChromeExtension: () => {
    if (typeof chromeApi?.runtime?.sendMessage !== 'function') {
      return;
    }
    return chromeApi.runtime.sendMessage(
      process.env.NEXT_PUBLIC_CHROME_EXTENSION_ID ?? '',
      {
        action: EXTENSION_ACTIONS.logout,
      },
    );
  },

  sendRedirectRequestToChromeExtension:
    async (): Promise<IExtensionMessage | void> => {
      return new Promise<IExtensionMessage | void>(
        (resolve) =>
          chromeApi?.runtime?.sendMessage(
            process.env.NEXT_PUBLIC_CHROME_EXTENSION_ID ?? '',
            {
              action: EXTENSION_ACTIONS.redirectReady,
            },
            resolve,
          ),
      );
    },

  sendToggleIframeToChromeExtension: () => {
    return chromeApi?.runtime?.sendMessage(
      process.env.NEXT_PUBLIC_CHROME_EXTENSION_ID ?? '',
      {
        action: EXTENSION_ACTIONS.toggleIframe,
      },
    );
  },

  sendClickTryGmail: () => {
    return chromeApi?.runtime?.sendMessage(
      process.env.NEXT_PUBLIC_CHROME_EXTENSION_ID ?? '',
      {
        action: EXTENSION_ACTIONS.clickGmail,
      },
    );
  },
};

// Foam Assist Utils (Kraken Extension)
export const foamAssistUtils = {
  // Message action constants
  LOGIN_SUCCESS_MESSAGE: 'foam-assist-login-success',

  sendTokens: () => {
    chromeApi?.runtime?.sendMessage(
      process.env.NEXT_PUBLIC_KRAKEN_EXTENSION_ID ?? '',
      {
        action: EXTENSION_ACTIONS.login,
        jwt: authApi.jwtAccessToken,
      },
    );
  },

  sendLogout: () => {
    if (typeof chromeApi?.runtime?.sendMessage !== 'function') {
      return;
    }
    chromeApi.runtime.sendMessage(
      process.env.NEXT_PUBLIC_KRAKEN_EXTENSION_ID ?? '',
      {
        action: EXTENSION_ACTIONS.logout,
      },
    );
  },

  sendOpenSidepanel: () => {
    return chromeApi?.runtime?.sendMessage(
      process.env.NEXT_PUBLIC_KRAKEN_EXTENSION_ID ?? '',
      {
        action: EXTENSION_ACTIONS.toggleIframe,
      },
    );
  },

  sendClickTryGmail: () => {
    return chromeApi?.runtime?.sendMessage(
      process.env.NEXT_PUBLIC_KRAKEN_EXTENSION_ID ?? '',
      {
        action: EXTENSION_ACTIONS.clickGmail,
      },
    );
  },
};
